import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { startWith, tap } from 'rxjs/operators';
import { DataSource } from '../data-table-new/datasource/datasource.component';
import { DataTableSortState } from '../data-table-new/directives/datatable-sort.directive';
import { DataTableState } from '../data-table-new/state/state.model';
import { StateService } from '../data-table-new/state/state.service';

export interface DataTableSimpleData {
  [key: string]: any;
}

interface TableData {
  key: string;
  value: string;
}

@Component({
  selector: 'vfs-data-table-simple',
  templateUrl: './data-table-simple.component.html',
  styleUrls: ['./data-table-simple.component.scss']
})
export class DataTableSimpleComponent implements OnChanges, OnInit {
  tableState$: Observable<DataTableState>;
  dataSource = new DataSource<TableData>();
  stateSubject$ = new Subject<DataTableState>();
  columns = ['key', 'value'];
  @Input() stateId = 'dataTableSimple';
  @Input() data: DataTableSimpleData;

  constructor(@Inject('StateService') protected stateService: StateService) {}

  ngOnChanges() {
    const state: DataTableState = this.stateService.get(this.stateId);
    if (this.stateService.get(this.stateId).sort.column === '') {
      state.sort.column = 'key';
      this.stateService.update(state);
    }
  }

  ngOnInit() {
    if (this.data) {
      this.tableState$ = this.stateSubject$.pipe(
        startWith(this.stateService.get(this.stateId)),
        tap(newState => this.refreshData(newState))
      );
    } else {
      console.warn('DataTable Simple: No data provided');
    }
  }

  protected refreshData(state: DataTableState) {
    this.dataSource.loading = true;
    let sortedData = this.sortData(this.data, state.sort);
    this.dataSource.setData(sortedData);
    this.dataSource.loading = false;
  }

  protected sortData(data: DataTableSimpleData, sort: DataTableSortState) {
    return this.transformData(data).sort((a, b) => {
      if (a[sort.column] < b[sort.column]) {
        return sort.direction === 'asc' ? -1 : 1;
      } else if (a[sort.column] > b[sort.column]) {
        return sort.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  protected transformData(data: DataTableSimpleData): TableData[] {
    let keys = Object.keys(data);
    let tableData: TableData[] = [];
    keys.forEach(key => {
      tableData.push({
        key,
        value: data[key]
      });
    });
    return tableData;
  }
}
